import React, { FC, memo, useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../redux/hooks';
import { getOils } from '../../redux/slices/oils';
import './OilsContainer.scss';

import OilCard from '../OilCard/OilCard';

const OilsContainer: FC = () => {
  const { t } = useTranslation();

  const oils = useAppSelector(getOils);

  const [activePerformaceWindow, setActivePerormanceWindow] = useState<
    string | null
  >(null);

  const handlePerformanceClick = useCallback((id: string | null) => {
    setActivePerormanceWindow(id);
  }, []);

  const amountLabel = useMemo(() => `${oils.length} ${t('Types')}`, [oils]);

  return (
    <div className="OilsContainer">
      <div className="OilsContainer__amount">{amountLabel}</div>

      <div className="OilsContainer__card_container">
        {oils.map((oil, idx) => (
          <OilCard
            key={idx}
            oil={oil}
            itemId={oil.id}
            isPerformanceActive={activePerformaceWindow === oil.id}
            onPerformanceClick={handlePerformanceClick}
          />
        ))}
      </div>
    </div>
  );
};

export default memo(OilsContainer);
